module.exports = __webpack_public_path__ + "c3fbd323e1bdc2e15cd9384b12f23263.jpg";